require('./bootstrap');

require('./landings/activations');
require('./landings/registrations');
require('./landings/jobs-users');
